import { type ThrottleSettings, default as lodashThrottle } from 'lodash-es/throttle';

import { DEFAULT_WAIT } from '@disy/lib/debounce';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- The function signature used (including `any`) is a direct copy from Lodash's `throttle` signature.
type FnType = (...args: any) => any;

/**
 * Wrapper around _.throttle to enforce our DEFAULT_WAIT
 */
export function throttle(func: FnType, wait = DEFAULT_WAIT, options?: ThrottleSettings): FnType {
  return lodashThrottle(func, wait, options);
}
